<div
    class="st-text-area-overlay-display"
    [class.st-text-area-overlay-required]="required() && !internalValue()"
    [class.st-text-area-overlay-valid]="required() && !internalValue()"
    [style.min-height]="minHeight()"
    [attr.maxrows]="maxRows()"
    [innerHTML]="displayValue() | linky: { stripPrefix: false } | highlight: textToHighlight() : false | unsafe: 'html'"></div>

<ng-template
    #overlay="cdkConnectedOverlay"
    cdkConnectedOverlay
    [cdkConnectedOverlayPanelClass]="panelClass()"
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayMinWidth]="_triggerRect()?.width"
    [cdkConnectedOverlayMinHeight]="minHeight()"
    [cdkConnectedOverlayPositions]="connectedPositions"
    [cdkConnectedOverlayOpen]="isPanelOpen()"
    (overlayKeydown)="onOverlayKeydown($event)"
    (attach)="panelAttached()">
    <textarea
        matInput
        cdkTrapFocus
        cdkTextareaAutosize
        class="st-text-area-overlay-input"
        [ngModel]="internalValue()"
        [placeholder]="label() || placeholder()"
        [required]="required()"
        [cdkAutosizeMinRows]="minRows()"
        [cdkAutosizeMaxRows]="maxOverlayRows()"
        [dir]="dir"
        [disabled]="disabled()"
        [maxLength]="maxLength()"
        (keydown.enter)="onTextAreaEnter($event)"
        (change)="onValueChanged()"
        (blur)="onFocusOut($event)"
        (ngModelChange)="onNgModelChanged($event)">
    </textarea>
</ng-template>
